// actions/insights/sales/productsInsightsReport/ProductsInsightsReportActionsTypes.ts

import { Action } from 'redux';
import type { ProductsInsightsReport } from 'model/ProductsInsightsReport';

export const PRODUCTS_INSIGHTS_REPORT_GET_START = 'PRODUCTS_INSIGHTS_REPORT_GET_START';
export const PRODUCTS_INSIGHTS_REPORT_GET_SUCCESS = 'PRODUCTS_INSIGHTS_REPORT_GET_SUCCESS';
export const PRODUCTS_INSIGHTS_REPORT_GET_ERROR = 'PRODUCTS_INSIGHTS_REPORT_GET_ERROR';

type ProductsInsightsGetStartAction = Action<typeof PRODUCTS_INSIGHTS_REPORT_GET_START>;

interface ProductsInsightsGetSuccessAction extends Action<typeof PRODUCTS_INSIGHTS_REPORT_GET_SUCCESS> {
    payload: {
        report: ProductsInsightsReport;
    };
}

type ProductsInsightsGetErrorAction = Action<typeof PRODUCTS_INSIGHTS_REPORT_GET_ERROR>;

export type ProductsInsightsReportAction =
    | ProductsInsightsGetStartAction
    | ProductsInsightsGetSuccessAction
    | ProductsInsightsGetErrorAction;
